(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('ManualMessageTriggerService', ManualMessageTriggerService);

    ManualMessageTriggerService.$inject = ['$resource'];

    function ManualMessageTriggerService ($resource) {

        var resourceUrl = '';

        return $resource(resourceUrl, {}, {

            'sendManualTrigger': {
                method: 'POST',
                params: {
                    messageType: '@messageType'
                },
                url: 'order/public/manual-trigger'
                // transformRequest: function(data) {
                //     return angular.toJson(data);
                // },
                // transformResponse: function(data) {
                //     return data;
                // }
            }

        });

    }
})();
